import { Row, Col, Card, Button, Input, Form, Skeleton, Divider, Select } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { useNavigate } from "react-router";
import apiPath from "../../constants/apiPath";
import DescriptionEditor from "../../components/DescriptionEditor";
import { useAppContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import Main from "../../components/layout/Main";
import { set } from "lodash";
import { faqCategory } from "../../helper/Var";
import NormalEditor from "../../components/NormalEditor";

function AddEditFaq() {
  const routeName = "help-center";
  const sectionName = "Faq"

  const [form] = Form.useForm();
  const { request } = useRequest();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [question, setQuestion] = useState("");
  const [arQuestion, setArQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [arAnswer, setArAnswer] = useState("");



  const fetchData = (id) => {
    request({
      url: apiPath.helpCenter + "/faq/" + id,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        form.setFieldsValue(data.data);
        setQuestion(data.data.question);
        setArQuestion(data.data.ar_question);
        setAnswer(data.data.answer);
        setArAnswer(data.data.ar_answer);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };



  const OnUpdate = (values) => {

    // Only English is required. Arabic is auto-translated on the server when
    // left blank, so it is optional here.
    if (question.trim() == "<p></p>" || question.trim() === "") return ShowToast(lang("Please Enter Question"), Severty.ERROR);
    if (answer.trim() == "<p></p>" || answer.trim() === "") return ShowToast(lang("Please Enter Answer"), Severty.ERROR);



    const { } = values;
    const payload = { ...values };

    payload.question = question;
    payload.ar_question = arQuestion;
    payload.answer = answer;
    payload.ar_answer = arAnswer;

    setLoading(true);
    request({
      url: params.id ? `${apiPath.helpCenter}/addEdit-faq/${params.id}` : `${apiPath.helpCenter}/addEdit-faq`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          navigate(`/${routeName}`);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    if (!params.id) return;
    setLoading(true);
    fetchData(params.id);
  }, [params.id]);

  return (
    <>

      <Card title={params.id ? lang("Add") : lang("Update") + sectionName}>
        {loading ? (
          [1, 2].map((item) => <Skeleton active key={item} />)
        ) : (
          <Form
            className="edit-page-wrap"
            form={form}
            onFinish={OnUpdate}
            autoComplete="off"
            layout="verticle"
            name="email_template_form"
          >
            <Row gutter={[24, 0]}>
              <Col span={24} sm={24}>
                <Form.Item
                  label={<> {lang("Category Name")}</>}
                  name="category"
                  rules={[
                    {
                      required: true,
                      message: lang("Please select the category!"),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder={lang("Select Category")}
                    showSearch
                  >
                    {faqCategory.map((item) => (
                      <Select.Option
                        key={item.value}
                        label={item.label}
                        value={item.value}
                      >
                        {item.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  label={lang("Question")}
                  name="question"
                  rules={[
                    { required: true, message: lang("Please Enter the question!") },
                  ]}
                >
                  <NormalEditor
                    value={question}
                    placeholder={lang("Enter Question Template")}
                    onChange={(data) => setQuestion(data)}
                  />
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  label={lang("Answer")}
                  name="answer"
                  rules={[
                    {
                      required: true,
                      message: lang("Please Enter the answer!"),
                    },
                  ]}
                >
                  <NormalEditor
                    value={answer}
                    placeholder={lang("Enter Answer Template")}
                    onChange={(data) => setAnswer(data)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Divider />

            <Row gutter={[24, 0]}>

              <Col span={24} md={12}>
                <Form.Item
                  label={lang("Question Arabic (optional — auto-translated if left blank)")}
                  name="ar_question"
                >
                  <NormalEditor
                    value={arQuestion}
                    placeholder={lang("Leave blank to auto-translate from English")}
                    onChange={(data) => setArQuestion(data)}
                  />
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  label={lang("Answer Arabic (optional — auto-translated if left blank)")}
                  name="ar_answer"
                >
                  <NormalEditor
                    value={arAnswer}
                    placeholder={lang("Leave blank to auto-translate from English")}
                    onChange={(data) => setArAnswer(data)}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item className="btn-row float-right">
              <Link
                className="ant-btn-primary btnStyle btnOutlineDelete  "
                to={`/${routeName}`}
              >
                {lang("Back")}
              </Link>
              <Button
                className="primary_btn btnStyle ms-2"
                loading={loading}
                htmlType="submit"
              >
                {lang("Submit")}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>

    </>
  );
}
export default AddEditFaq;
